import { AppLanguage } from '../types/app';
import { Cases, Case, UiCase, Texts, SubCategories, Categories } from '../types';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { stripText } from './textsHelpers';
require('dayjs/locale/da');
dayjs.extend(advancedFormat);

export const getCategoryName = (texts: Texts, alias: number) => {
  const category = texts.teamShareTexts?.categories.find(
    (category: Categories) => category.alias === alias,
  )?.name;
  return category || '';
};

export const getSubCategoryName = (texts: Texts, alias: number) => {
  const subCategory = texts.teamShareTexts?.subcategories.find(
    (category: SubCategories) => category.alias === alias,
  )?.name;
  return subCategory || '';
};

export const getEmploymentTypeName = (texts: Texts, employmentType: string) => {
  const name = texts.teamShareTexts?.employmentTypes.find(
    (emp) => emp.employmentType === employmentType,
  )?.name;
  return name || '';
};

export const getFormattedDateWithWeekDayFromString = (date: string, language: string) => {
  return date
    ? language === AppLanguage.Danish
      ? dayjs(date).locale('da-DK').format('dddd D. MMMM YYYY')
      : dayjs(date).locale('en-GB').format('dddd MMMM D, YYYY')
    : '';
};

export const getFormattedDateFromString = (date: string, language: string) => {
  return date
    ? language === AppLanguage.Danish
      ? dayjs(date).locale('da-DK').format('D. MMMM YYYY')
      : dayjs(date).locale('en-GB').format('MMMM D, YYYY')
    : '';
};

export const getFormattedDateTimeFromString = (date: string, language: string) => {
  return date
    ? language === AppLanguage.Danish
      ? dayjs(date).locale('da-DK').format('D. MMMM YYYY H:mm')
      : dayjs(date).locale('en-GB').format('MMMM D, YYYY h:mm A')
    : '';
};

export const showPhoneNumberForCaseWorker = (department: string, phone: string | undefined) => {
  return department !== 'KAR' && phone;
};

export const readyCasesForUi = (
  cases: Cases | null,
  states: Case['state'][],
  language: AppLanguage,
  texts?: Texts | null,
) => {
  if (!texts) {
    return null;
  }
  const tableTexts = texts.caseOverviewTexts?.table;
  if (!tableTexts) {
    return null;
  }

  const casesWithState: Cases['cases'] | null =
    cases && cases.cases.length > 0 ? cases.cases.filter((c) => states.includes(c.state)) : null;

  const casesReadyForTable: UiCase[] | null =
    casesWithState &&
    casesWithState.map((c: Case) => {
      return {
        [stripText(tableTexts.subject.title)]:
          getCategoryName(texts, c?.categoryAlias) ||
          getSubCategoryName(texts, c?.subcategoryAlias),
        [stripText(tableTexts.caseNumber.title)]: c?.caseNumber ?? '',
        [stripText(tableTexts.creationDate.title)]: c?.creationDate
          ? dayjs(c.creationDate).locale(language).format('Do MMM YYYY')
          : '',
        [stripText(tableTexts.employerName.title)]: c?.employerName ?? '',
        [stripText(tableTexts.caseOwner.title)]: c?.caseOwner ? c.caseOwner.name : '',
        Id: c?.caseId,
      } as UiCase;
    });

  return casesReadyForTable;
};
